import { BaseApi } from '@/api/baseApi';
import {TUseArchiveForm, TResult} from "@/pages/Archive/useArchive";


export class Archive extends BaseApi {

    public async createArchive(data: TUseArchiveForm):Promise<TResult> {
        return await this.post('/create', data);
    };
}
